module.exports = __webpack_public_path__ + "static/jetfuel.b28f64c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/covers/jetfuel.png
// module id = 87
// module chunks = 35783957827783 73016943110679